module.exports = __webpack_public_path__ + "img/PlateringFullPage.314df673.png";